import React, { Component } from 'react';
import Utils from 'libs/Utils';
import PropTypes from 'prop-types';

import './styles.css';
import caret from './img/caret.svg';
import eye from './img/eye.svg';
import shapeShift from './img/shapeShift.svg';

class OrderInformation extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);

    this.state = {
      show: false,
    };
  }

  toggle() {
    this.setState({
      show: !this.state.show,
    });
  }

  render() {
    let classname = 'order-information';
    if (this.state.show) classname += ' order-information--show';

    let toCoinIcon;
    switch (this.props.exchangeStore.exchange.toCoin.iconType) {
      case 'vector':
        toCoinIcon = (
          <img
            className="order-information__icon"
            src={this.props.exchangeStore.exchange.toCoin.iconUrl}
            alt={`${this.props.exchangeStore.exchange.toCoin.name} (${this.props.exchangeStore.exchange.toCoin.symbol}) icon`}
            width="28"
            height="28"
          />
        );
        break;
      case 'pixel':
        toCoinIcon = (
          <img
            className="order-information__icon"
            src={`${this.props.exchangeStore.exchange.toCoin.iconUrl}?size=56`}
            alt={`${this.props.exchangeStore.exchange.toCoin.name} (${this.props.exchangeStore.exchange.toCoin.symbol}) icon`}
            width="28"
            height="28"
          />
        );
        break;
      default:
        toCoinIcon = (
          <span className="order-information__icon order-information__icon--placeholder" />
        );
    }

    let fromCoinIcon;
    switch (this.props.exchangeStore.exchange.fromCoin.iconType) {
      case 'vector':
        fromCoinIcon = (
          <img
            className="order-information__icon"
            src={this.props.exchangeStore.exchange.fromCoin.iconUrl}
            alt={`${this.props.exchangeStore.exchange.fromCoin.name} (${this.props.exchangeStore.exchange.fromCoin.symbol}) icon`}
            width="28"
            height="28"
          />
        );
        break;
      case 'pixel':
        fromCoinIcon = (
          <img
            className="order-information__icon"
            src={`${this.props.exchangeStore.exchange.fromCoin.iconUrl}?size=56`}
            alt={`${this.props.exchangeStore.exchange.fromCoin.name} (${this.props.exchangeStore.exchange.fromCoin.symbol}) icon`}
            width="28"
            height="28"
          />
        );
        break;
      default:
        fromCoinIcon = (
          <span className="order-information__icon order-information__icon--placeholder" />
        );
    }

    return (
      <div className={classname}>
        <button className="order-information__toggle" onClick={this.toggle}>
          {this.state.show ? 'Hide' : 'Show'} order information <img className="order-information__caret" src={caret} width="13" height="8" alt="Toggle order information" />
        </button>
        <div className="order-information__pane">
          <div className="order-information__content">
            {this.props.exchangeStore.exchange.toTransaction.id ?
              <div className="order-information__form-control">
                <div className="order-information__label">
                  Receive transaction ID ({this.props.exchangeStore.exchange.toCoin.name})
                </div>
                <div className="order-information__date">
                  {Utils.timestampToDate(this.props.exchangeStore.exchange.toTransaction.createdAt)}
                </div>
                <div className="order-information__input">
                  {toCoinIcon}
                  <div className="order-information__value">
                    {this.props.exchangeStore.exchange.toTransaction.id}
                  </div>
                  {this.props.exchangeStore.exchange.toTransaction &&
                  this.props.exchangeStore.exchange.toTransaction.url ?
                    <a className="order-information__link" target="_blank" href={this.props.exchangeStore.exchange.toTransaction.url}>
                      <img className="order-information__img" width="17" height="12" src={eye} alt="Block explorer" />
                    </a>
                  : null}
                </div>
              </div>
            : null}

            <div className="order-information__form-control">
              <div className="order-information__label">
                Receive address ({this.props.exchangeStore.exchange.toCoin.name})
              </div>
              <div className="order-information__input">
                {toCoinIcon}
                <div className="order-information__value">
                  {this.props.exchangeStore.exchange.toAddress}
                </div>
              </div>
            </div>

            {this.props.exchangeStore.exchange.fromTransaction.id ?
              <div className="order-information__form-control">
                <div className="order-information__label">
                  Send transaction ID ({this.props.exchangeStore.exchange.fromCoin.name})
                </div>
                <div className="order-information__date">
                  {Utils.timestampToDate((
                    this.props.exchangeStore.exchange.fromTransaction.createdAt
                  ))}
                </div>
                <div className="order-information__input">
                  {fromCoinIcon}
                  <div className="order-information__value">
                    {this.props.exchangeStore.exchange.fromTransaction.id}
                  </div>
                </div>
              </div>
            : null}

            <div className="order-information__form-control">
              <div className="order-information__label">
                Refund address ({this.props.exchangeStore.exchange.fromCoin.name})
              </div>
              <div className="order-information__input">
                {fromCoinIcon}
                <div className="order-information__value">
                  {this.props.exchangeStore.exchange.refundAddress}
                </div>
              </div>
            </div>

            {this.props.exchangeStore.exchange.provider && this.props.exchangeStore.exchange.provider.name === 'shapeshift' ?
              <div className="order-information__form-control">
                <div className="order-information__label">
                  ShapeShift Order ID
                </div>
                <div className="order-information__input">
                  <img
                    className="order-information__icon"
                    src={shapeShift}
                    alt="Provider Order ID"
                    width="22"
                    height="25"
                  />
                  <div className="order-information__value">
                    {this.props.exchangeStore.exchange.provider.orderId}
                  </div>
                </div>
              </div>
            : null}
          </div>
        </div>
      </div>
    );
  }
}

OrderInformation.propTypes = {
  exchangeStore: PropTypes.shape({
    exchange: PropTypes.shape({
      fromTransaction: PropTypes.shape({
        id: PropTypes.string,
        createdAt: PropTypes.number,
      }),
      toTransaction: PropTypes.shape({
        id: PropTypes.string,
        createdAt: PropTypes.number,
        url: PropTypes.string,
      }),
      fromCoin: PropTypes.shape({
        name: PropTypes.string,
        symbol: PropTypes.string,
        iconType: PropTypes.string,
        iconUrl: PropTypes.string,
      }),
      toCoin: PropTypes.shape({
        name: PropTypes.string,
        symbol: PropTypes.string,
        iconType: PropTypes.string,
        iconUrl: PropTypes.string,
      }),
      provider: PropTypes.shape({
        name: PropTypes.string,
        orderId: PropTypes.string,
      }),
      toAddress: PropTypes.string,
      refundAddress: PropTypes.string,
    }),
  }).isRequired,
};

export default OrderInformation;



// WEBPACK FOOTER //
// ./src/components/OrderInformation/index.jsx